import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { EventsRepository } from '@app/shared/state/events/events.repository';

@Component({
  selector: 'slotcom-slotcard-progress-modal',
  templateUrl: './slotcard-progress.component.html',
  styleUrls: ['./slotcard-progress.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule, NavigationButtonComponent],
})
export class SlotcardProgressModalComponent implements OnInit {
  slotcardProgressModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private eventsRepo = inject(EventsRepository);

  event: LimitedTimeEvent;

  ngOnInit(): void {
    this.event = this.eventsRepo.getEventById(this.slotcardProgressModalData.properties.eventId);
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.slotcardProgressModalData.id, ModalType.Persisted, this.slotcardProgressModalData)
    );
  }

  openSlotcard(): void {
    if (
      this.eventsRepo.hasEvent(this.slotcardProgressModalData.properties.eventId) &&
      this.slotcardProgressModalData.properties.finished !== true
    ) {
      this.eventManager.openModal(
        new Modal(NonPersistedModalName.SlotcardModalComponent, ModalType.View, this.slotcardProgressModalData)
      );
    }

    this.closeModal();
  }
}
